export const MONO = "'Fira Code', 'SF Mono', 'Fira Mono', 'Consolas', 'Menlo', monospace";
export const SANS = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";
